import { Offering } from './offering.model';
import { Service } from './service.model';
import { LabProfileMaterialClass } from './lab-profile-material-class.model';
import { LabProfileRestorationType } from './lab-profile-restoration-type.model';
import { LabProfileShade } from './lab-profile-shade.model';
import { ModelHelper } from '../classes/model-helper';

export class AllCompanyElements {
	code: string;
	offerings: Offering[];
	services: Service[];
	materialClasses: LabProfileMaterialClass[];
	restorations: LabProfileRestorationType[];
	shades: LabProfileShade[];

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns AllCompanyElements
	 */
	static map(data: any, item: AllCompanyElements = new AllCompanyElements()): AllCompanyElements {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return AllCompanyElements
	 */
	public map(data: any): AllCompanyElements {
		ModelHelper.map(data, this, 'code');
		ModelHelper.map(data, this, 'offerings', Offering);
		ModelHelper.map(data, this, 'services', Service);
		ModelHelper.map(data, this, 'materialClasses', LabProfileMaterialClass);
		ModelHelper.map(data, this, 'restorations', LabProfileRestorationType);
		ModelHelper.map(data, this, 'shades', LabProfileShade);

		return this;
	}
}
